export enum ProfileMediaTypeEnum {
  BANNER = 'banner',
  AVATAR = 'avatar'
}